/// <summary>
/// 센서 해제 모드
/// </summary>
export enum ESensorReleaseMode {
  /// <summary>
  /// 자동 해제
  /// </summary>
  RELEASE_AUTO,
  /// <summary>
  /// 관리자에 의해 해제
  /// </summary>
  RELEASE_BY_ADMIN
}
